import { ClusterCreate_clusterCreate_errors } from "@saleor/cluster/types/ClusterCreate";
import { commonMessages } from "@saleor/intl";
import { ClusterErrorCode } from "@saleor/types/globalTypes";
import { IntlShape } from "react-intl";

import commonErrorMessages from "./common";

function getClusterErrorMessage(
  err: Omit<ClusterCreate_clusterCreate_errors, "__typename"> | undefined,
  intl: IntlShape
): string {
  if (err) {
    switch (err.code) {
      case ClusterErrorCode.REQUIRED:
        return intl.formatMessage(commonMessages.requiredField);
      case ClusterErrorCode.INVALID:
        return intl.formatMessage(commonErrorMessages.invalid);
      default:
        return intl.formatMessage(commonErrorMessages.unknownError);
    }
  }

  return undefined;
}

export default getClusterErrorMessage;
